import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import * as moment from "moment";
import _ from 'lodash';
import { Chart } from 'chart.js';
import { AppConfig } from '../../providers/config';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-report-enrolments',
  templateUrl: 'report-enrolments.html',
})
export class ReportEnrolmentsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  mtd: any[] = [];
  ytd: any[] = [];
  mtd_chart: any[] = [];
  ytd_chart: any[] = [];
  province_mtd_count: any[] = [];
  totalcount: number;
  mtd_counts: any[] = [];
  mtd_provinces: any[] = [];
  mtd_colors: any[] = [];
  ytd_counts: any[] = [];
  ytd_provinces: any[] = [];
  ytd_colors: any[] = [];

  prov_chart: any[] = [];
  provinces: any[] = [];
  provinces_counts: any[] = [];
  provinces_months: any[] = [];
  province_color: string;

  constructor(    
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider
    
    ) {
    this.provinces = AppConfig.Global.provinces;
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.database
      .getPatientsByProgramMTD(this.program_id, moment().format('YYYY'), moment().format('MM'))
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((patients) => {
        // console.log('Patients: MTD', patients);
        this.mtd = patients;
        this.mtd_counts = [];
        this.mtd_provinces = [];
        this.mtd_colors = [];
        AppConfig.Global.provinces.forEach(province => {
          const count = this.mtd.filter((obj) => obj.province === province.short).length
          this.mtd_counts.push(count);
          this.mtd_provinces.push(province.short + ' (' + count + ')');
          this.mtd_colors.push(province.color);
        });
        setTimeout(() => {
          this.mtd_chart = new Chart('mtd_chart', {
            type: 'bar',
            data: {
              labels: this.mtd_provinces,
              datasets: [
                {
                  data: this.mtd_counts,
                  backgroundColor: this.mtd_colors,
                  fill: true
                }
              ]
            },
            options: {
              title: {
                display: true,
                text: moment().format("MMMM") + ' Enrolments'
              },
              legend: {
                display: false,
                position: 'bottom'
              },
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Province'
                },
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Enrolments'
                },
                  ticks: {
                    beginAtZero: true,
                    max: 20
                }
                }],
              }
            }
          });
        },100)
        
      });

      this.database
      .getPatientsByProgramYTD(this.program_id, moment().format('YYYY'))
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((patients) => {
        // console.log('Patients YTD: ', patients);
        this.ytd = patients;
        this.ytd_counts = [];
        this.ytd_provinces = [];
        this.ytd_colors = [];
        AppConfig.Global.provinces.forEach(province => {
          const count = this.ytd.filter((obj) => obj.province === province.short).length
          this.ytd_counts.push(count);
          this.ytd_provinces.push(province.short + ' (' + count + ')');
          this.ytd_colors.push(province.color);
        });
        setTimeout(() => {
          this.ytd_chart = new Chart('ytd_chart', {
            type: 'bar',
            data: {
              labels: this.ytd_provinces,
              datasets: [
                {
                  data: this.ytd_counts,
                  backgroundColor: this.ytd_colors,
                  fill: true
                }
              ]
            },
            options: {
              title: {
                display: true,
                text: moment().format("YYYY") + ' Enrolments'
              },
              legend: {
                display: false,
                position: 'bottom'
              },
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Province'
                },
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Enrolments'
                },
                  ticks: {
                    beginAtZero: true,
                    max: 20
                }
                }],
              }
            }
          });
          this.provinceChange('All');
        },100)
      });

      
      
    });
  }

  ngOnDestroy() {
    console.log('Leave enrolment report view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  provinceChange(ev)  {
    // console.log(ev);
    this.provinces_counts = [];
    this.provinces_months = [];
    AppConfig.Global.months.forEach(month => {
      let count = 0;
      if(ev === 'All') {
        count = this.ytd.filter((obj) => moment.unix(obj.createdAt.seconds).format('MMM') === month).length
      } else {
        count = this.ytd.filter((obj) => (moment.unix(obj.createdAt.seconds).format('MMM') === month) && (obj.province === ev)).length
      }
      this.provinces_counts.push(count);
      this.provinces_months.push(month + ' (' + count + ')');
    });
    if(ev === 'All')  {
      this.province_color = 'Blue';
    } else {
      this.province_color = this.provinces.filter((obj) => obj.short === ev)[0].color;
    }
    setTimeout(() => {
      this.prov_chart = new Chart('prov_chart', {
        type: 'bar',
        data: {
          labels: this.provinces_months,
          datasets: [
            {
              data: this.provinces_counts,
              backgroundColor: this.province_color,
              fill: true
            }
          ]
        },
        options: {
          title: {
            display: true,
            text: 'Enrolments by Province'
          },
          legend: {
            display: false,
            position: 'bottom'
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Month'
            },
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Enrolments'
            },
              ticks: {
                beginAtZero: true,
                max: 20
            }
            }],
          }
        }
      });
    },100)
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-enrolments/report-enrolments.ts